/* eslint-disable import/prefer-default-export */
import { humanizeValue } from '../../utils';

const tooltipFormatter = (params, unit) => {
  const colorSpan = (color) => `<span
    style="display:inline-block;
    margin-right:5px;
    width:9px;
    height:9px;
    background-color:${color}">
    </span>`;
  let htmlString = `<div
      style="
      width:200px;
      overflow: hidden;
      font-size:14px;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: block;">
      ${params[0].seriesName}</div>`;
  params.forEach((newSeries) => {
    const { humanizedNumber, humanizedUnit } = humanizeValue(newSeries.value, unit);
    const seriesHtml = `<div
      style="
      width:200px;
      overflow: hidden;
      font-size:12px;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: block;">
        <span style="display:inline-block;min-width: 60px;">${colorSpan(newSeries.color)}  ${humanizedNumber || ''} ${humanizedUnit || ''}</span>
        <span style="display:inline-block;padding-left:10px">${newSeries.name}</span>
      </div>`;
    htmlString += seriesHtml;
  });
  return htmlString;
};

export const createOptions = (cellData, colors, max, dimensionName, filters, unit) => {
  const options = {
    grid: {
      left: 10,
      right: 10,
      top: 10,
      bottom: 10,
    },
    tooltip: {
      show: true,
      trigger: 'axis',
      axisPointer: {
        type: 'none',
      },
      extraCssText: 'z-index: 999',
      position: ['50%', '50%'],
      formatter: (params) => tooltipFormatter(params, unit),
      padding: 5,
      textStyle: {
        overflow: 'truncate',
      },
    },
    xAxis: {
      type: 'value',
      show: false,
      axisLabel: {
        formatter: '{value} {name}',
      },
      max,
    },
    yAxis: {
      type: 'category',
      show: false,
      data: [dimensionName],
    },
    series: [],
  };
  const series: Array<{
    name: string;
    type: string;
    data: [any];
    barGap?: string | number;
    barWidth?: string;
    color: string;
    showBackground: boolean;
    barMaxWidth?: number | string;
    barCategoryGap?: number | string;
  }> = [];
  if (cellData) {
    cellData.forEach((eachRange, i) => {
      series.push({
        name: dimensionName,
        type: 'bar',
        showBackground: true,
        data: [
          {
            name: filters[i],
            value: eachRange,
          },
        ],
        color: colors[i],
        barMaxWidth: 5,
        barGap: 4,
      });
    });
  }
  const newOption = { ...options, series };
  return newOption;
};
